import cashRequest from "@/api/finance/cash-request";
import { baseState, baseMutations } from "@/store/mixins";
import { isEmpty } from "lodash";

export const state = {
    ...baseState,
    employees: [],
    currencies: [],
    banks: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_EMPLOYEES(state, data) {
        state.employees = data;
    },
    SET_CURRENCIES(state, data) {
        state.currencies = data;
    },
    SET_BANKS(state, data) {
        state.banks = data;
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.currentPage,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return cashRequest.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return cashRequest.store(data);
    },

    async find(context, id) {
        if (isEmpty(context.state.edit_data)) {
            let response = await cashRequest.find(id);
            context.commit("SET_EDIT_DATA", response.data);
        }
    },

    update(context, { id, data }) {
        return cashRequest.update(id, data);
    },

    destroy(context, id) {
        return cashRequest.destroy(id);
    },

    approveOrReject(context, { id, data }) {
        return cashRequest.approveOrReject(id, data);
    },

    bankSlip(context, { id, data }) {
        return cashRequest.bankSlip(id, data);
    },

    photoUpload(context, data) {
        return cashRequest.photoUpload(data);
    },

    async getEmployees(context) {
        let response = await cashRequest.employees();
        context.commit("SET_EMPLOYEES", response.data);
    },

    async getCurrencies(context) {
        let response = await cashRequest.currencies();
        context.commit("SET_CURRENCIES", response.data);
    },

    async getBanks(context, attributes = {}) {
        const params = {};
        if (attributes.employee_id) params.employee_id = attributes.employee_id;
        let response = await cashRequest.banks({ params });
        context.commit("SET_BANKS", response.data);
    }
};
